/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useQuery } from '@apollo/client';

import i18n from '../../i18n/i18n';
import useToken from '../../hooks/use-token';
import { GET_CUSTOMIZATION } from '../../api/customization';
import Language from '../../utils/language';

type MainProps = {
  children: ReactNode
};

const defaultProps = {};

const Main: React.FC<MainProps> = ({ children }: MainProps): ReactElement => {
  const token = useToken();

  const {
    called: calledCustomization,
    loading: loadingCustomization,
    data: customizationData,
  } = useQuery(GET_CUSTOMIZATION, {
    context: { headers: { authorization: `Bearer ${token}` } },
  });

  useEffect(() => {
    if (calledCustomization && !loadingCustomization) {
      const language = new Language(i18n);
      language.setLanguage(customizationData?.customization?.language);
    }
  }, [calledCustomization, loadingCustomization, customizationData]);

  return (
    <div>
      {children}
    </div>
  );
};

Main.defaultProps = defaultProps;

export default Main;
